export const BASE_URL = process.env.REACT_APP_BASE_URL
//export const BASE_URL = 'http://10.0.103.147:5021'

export const EstadoContenido = {
    EnRevision: "ER",
    EnAprobacion: "EA",
    Publicado: "PU"
}

